import React from 'react'
import PropTypes from 'prop-types'
import { uniqueId } from '../../utils'
import { getWebpImage } from '../../utils'
import './image-gallery.scss'

export default class ImageGallery extends React.Component {
  render() {
    const images = this.props.images
    if (images.length === 0) {
      console.warn('no images for product present')
      return null;
    }
    const GALLERY_ID = uniqueId()
    const isWithPreview = images.length > 1
    return (
      <div className="gallery">
        <div className="gallery__carousel">
          <amp-carousel id={GALLERY_ID}
            width="300"
            height="200"
            layout="responsive"
            type="slides">
            {images.map((img) => (
              <figure>
                <amp-img
                  class="gallery__image"
                  alt={img.image_alt}
                  width="375"
                  height="300"
                  layout="responsive"
                  key={img.image_url + '-webp'}
                  src={getWebpImage(img.image_url)}
                >
                  <amp-img
                    fallback=""
                    class="gallery__image"
                    key={img.image_url}
                    src={img.image_url}
                    width="375"
                    height="300"
                    layout="responsive"
                    alt={img.image_alt}
                  ></amp-img>
                </amp-img>

              </figure>
            ))}
          </amp-carousel>
        </div>
        {isWithPreview && (
          <div className="carousel-preview">
            {images.map((img, index) => (
              <button
                aria-label="next-image"
                key={img.image_url}
                on={`tap:${GALLERY_ID}.goToSlide(index=${index})`}
              >
                <amp-img
                  src={img.image_url}
                  width="60"
                  height="40"
                  layout="responsive"
                  alt={img.image_alt}
                ></amp-img>
              </button>
            ))}
          </div>
        )}
      </div>
    )
  }
}

ImageGallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    image_url: PropTypes.string,
    image_alt: PropTypes.string,
  }))
}



// WEBPACK FOOTER //
// ./src/components/image-gallery/image-gallery.js